<template>
  <div class="chart-card">
    <p>Device Uptime Graph</p>
    <canvas ref="uptimeCanvas"></canvas>
  </div>
</template>

<script>

import Chart from "chart.js/dist/Chart.js";

export default {
  name: "UptimeChart",

  props: {
    apiData: {
      type: Object,
      required: true
    }
  },
  beforeDestroy() {
  if (this.chart) {
    this.chart.destroy();
  }
},

  data() {
    return {
      chart: null
    };
  },

  mounted() {
    if (this.apiData) {
      this.renderChart();
    }
  },

  watch: {
    apiData: {
      deep: true,
      handler() {
        if (this.chart) {
          this.chart.destroy();
        }
        this.renderChart();
      }
    }
  },

  methods: {
    renderChart() {

      // Safety check
      if (!this.apiData || !this.apiData.result) return;

      //const records = this.apiData.result.records;
      const records = [...this.apiData.result.records];

      if (!records || records.length === 0) return;

      // Sort by date
      records.sort((a, b) => new Date(a.report_date) - new Date(b.report_date));

      // Group by Feeder Pillar
      const grouped = {};

      records.forEach(item => {
        if (!grouped[item.feeder_pillar_no]) {
          grouped[item.feeder_pillar_no] = [];
        }
        grouped[item.feeder_pillar_no].push(item.uptime_percent);
      });

      const labels = [...new Set(records.map(r => r.report_date))];

      const colors = [
        "#ff6384",
        "#36a2eb",
        "#4bc0c0",
        "#9966ff",
        "#ff9f40"
      ];

      const datasets = [];
      let index = 0;

      Object.keys(grouped).forEach(key => {
        datasets.push({
          label: "FP " + key,
          data: grouped[key],
          borderColor: colors[index % colors.length],
          backgroundColor: colors[index % colors.length],
          fill: false,
          borderWidth: 2,
          lineTension: 0.3   // smooth curve
        });
        index++;
      });

      this.chart = new Chart(this.$refs.uptimeCanvas, {
        type: "line",
        data: {
          labels: labels,
          datasets: datasets
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: "top"
          },
          scales: {
            yAxes: [{
              ticks: {
                min: 0,
                max: 100
              },
              scaleLabel: {
                display: true,
                labelString: "Uptime %"
              }
            }],
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: "Date"
              }
            }]
          }
        }
      });
    }
  }
};

</script>

<style scoped>
.chart-card {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  height: 400px;
}
</style>
